<template>
  <Layout>
    <div class="error-page-wrapper d-flex align-items-center justify-content-center">
      
      <!-- Background Decorations - Changed to Soft Red -->
      <div class="bg-decoration blur-1"></div>
      <div class="bg-decoration blur-2"></div>

      <div class="error-content text-center px-3">
        
        <!-- Error Code 500 - Now in Danger Colors -->
        <div class="error-code-container mb-2">
          <h1 class="error-code-display">500</h1>
          <div class="error-code-overlay">500</div>
        </div>

        <!-- Message Box -->
        <div class="message-box">
          <h2 class="font-weight-bold text-dark mb-3">Oups ! Erreur technique</h2>
          <p class="text-muted mb-5 mx-auto" style="max-width: 450px;">
            Désolé, un problème inattendu est survenu sur nos serveurs. 
            Notre équipe technique a été alertée et travaille activement à la résolution.
          </p>

          <!-- Action Buttons -->
          <div class="d-flex justify-content-center gap-3">
            <!-- Refresh Button -->
            <b-button 
              variant="white" 
              @click="retryConnection" 
              class="btn-white-pill px-4 py-3 shadow-sm me-3"
            >
              <i class="fas fa-sync-alt me-2"></i> RÉESSAYER
            </b-button>

            <!-- Back to Dashboard - Now Danger Red -->
            <b-button 
              variant="primary" 
              @click="$router.push('/dashboard').catch(() => {})"
              class="btn-danger-pill px-5 py-3 shadow-lg"
            >
              <i class="fas fa-home me-2"></i> TABLEAU DE BORD
            </b-button>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/LayoutScreen.vue";

export default {
  name: "ServerErrorPage",
  components: { Layout },
  methods: {
    retryConnection() {
      const urlParams = new URLSearchParams(window.location.search);
      const returnUrl = urlParams.get('from');
      if (returnUrl) {
        this.$router.push(decodeURIComponent(returnUrl)).catch(() => {});
      } else {
        this.$router.push('/dashboard').catch(() => {});
      }
    }
  }
};
</script>

<style scoped>
.error-page-wrapper {
  min-height: 85vh;
  position: relative;
  overflow: hidden;
  background-color: #fffafb; /* Very slight red tint to the background */
}

/* --- Typography 500 (Danger Theme) --- */
.error-code-container {
  position: relative;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-code-display {
  font-size: 10rem;
  font-weight: 900;
  color: #fee2e2; /* Very light red */
  margin: 0;
  letter-spacing: -5px;
}

.error-code-overlay {
  position: absolute;
  font-size: 5rem;
  font-weight: 800;
  color: #ef4444; /* Professional Danger Red */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -40%);
  opacity: 0.15;
}

/* --- Message & Box --- */
.message-box h2 {
  font-size: 2rem;
  letter-spacing: -0.5px;
}

.text-muted {
  font-size: 1.1rem;
  line-height: 1.6;
}

/* --- Buttons --- */
.btn-danger-pill {
  background-color: #ef4444; /* Main Danger Red */
  border: none;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  color: white !important;
}

.btn-danger-pill:hover {
  background-color: #dc2626; /* Darker red on hover */
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(239, 68, 68, 0.3) !important;
}

.btn-white-pill {
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.9rem;
  color: #64748b;
  transition: all 0.3s ease;
}

.btn-white-pill:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-3px);
}

/* --- Decorations - Changed to Red Glows --- */
.bg-decoration {
  position: absolute;
  border-radius: 50%;
  z-index: 0;
}

.blur-1 {
  width: 300px;
  height: 300px;
  background: rgba(239, 68, 68, 0.07); /* Red glow */
  top: -100px;
  right: -50px;
  filter: blur(80px);
}

.blur-2 {
  width: 250px;
  height: 250px;
  background: rgba(239, 68, 68, 0.07); /* Red glow */
  bottom: -50px;
  left: -50px;
  filter: blur(60px);
}

@media (max-width: 576px) {
  .error-code-display { font-size: 7rem; }
  .error-code-overlay { font-size: 3.5rem; }
  .d-flex { flex-direction: column; }
  .btn-danger-pill, .btn-white-pill { width: 100%; margin: 5px 0; }
}
</style>
